export const uncertainityCalculator = (
  deviceParams: any,
  etalonParams: any,
  referenceValue: number,
  measuredValue: number,
  siPrefix: any
) => {
  const deviceParam = deviceParams;
  const siFactorDevice = Number(siPrefix.data.find((i: any) => i.id === deviceParam.si_prefix_id)?.factor) || 1;

  const etalonParam = etalonParams
    //Filters the etalon parameters to find the one that matches the device parameter
    .filter(
      (i: any) => i.etalon_function_id === deviceParam.etalon_function_id && i.etalon_id === deviceParam.etalon_id
    )
    // Sorts the etalon parameters by range and finds the closest one to the device parameter's reference value
    .reduce((prev: any, curr: any) => {
      const siFactorPrev = Number(siPrefix.data.find((i: any) => i.id === prev.si_prefix_id)?.factor) || 1;
      const siFactorCurr = Number(siPrefix.data.find((i: any) => i.id === curr.si_prefix_id)?.factor) || 1;

      return Math.abs(siFactorDevice * referenceValue - siFactorCurr * curr.range) <
        Math.abs(siFactorDevice * referenceValue - siFactorPrev * prev.range)
        ? curr
        : prev;
    });
  const devData = {
    reference_value: Number(referenceValue),
    measured_value: Number(measuredValue),
    resolution: Number(deviceParam.resolution),
    u_precentage: Number(deviceParam.u_precentage),
    u_digit: Number(deviceParam.u_digit),
    u_value: Number(deviceParam.u_value),
    si_symbol: deviceParam.si_prefix_symbol,
    si_factor: siFactorDevice,
    unit: deviceParam.unit_symbol,
  };

  const etalonData = {
    resolution: Number(etalonParam.resolution),
    u_precentage: Number(etalonParam.u_precentage),
    u_digit: Number(etalonParam.u_digit),
    u_value: Number(etalonParam.u_value),
    u_standard: Number(etalonParam.u_standard),
    si_symbol: etalonParam.si_prefix_symbol,
    si_factor: Number(siPrefix.data.find((i: any) => i.id === etalonParam.si_prefix_id)?.factor) || 1,
  };

  const deviation = devData.measured_value - devData.reference_value;
  const allowed_deviation =
    devData.reference_value * (devData.u_precentage / 100) + devData.u_digit * devData.resolution + devData.u_value;

  const Ues =
    (devData.reference_value * (etalonData.u_precentage / 100) * devData.si_factor +
      etalonData.u_digit * etalonData.resolution * etalonData.si_factor +
      etalonData.u_value * etalonData.si_factor) /
    Math.sqrt(3);

  const Uev = (etalonData.u_standard * etalonData.si_factor) / Math.sqrt(3);

  const Umf = (devData.resolution * devData.si_factor) / (2 * Math.sqrt(3));

  const Uy = parseFloat(Math.sqrt(Uev * Uev + Umf * Umf + Ues * Ues).toFixed(10));

  let uncertainity: any = Uy * 2; // Kiterjesztett bizonytalanság

  //Round uncertainity to 2 decimal places
  if (uncertainity < 1 || uncertainity > 10) {
    for (let i = 0; i < siPrefix.data.length; i++) {
      const scaled = uncertainity / siPrefix.data[i].factor;
      if (scaled >= 1 && scaled <= 1000) {
        uncertainity = `${scaled.toFixed(2)} ${siPrefix.data[i].symbol}${devData.unit}`;
        break;
      }
    }
  } else {
    uncertainity = `${uncertainity.toFixed(2)} ${devData.unit}`;
  }

  return {
    deviation: parseFloat(deviation.toFixed(8)),
    deviation_precentage:
      devData.reference_value > 0
        ? parseFloat(((devData.measured_value / devData.reference_value - 1) * 100).toFixed(2))
        : 0,
    allowed_deviation: parseFloat(allowed_deviation.toFixed(3)),
    uncertainity: uncertainity,
    passed: Math.abs(deviation) <= allowed_deviation ? 1 : 0,
  };
};
